import moment from "moment";

export default {
    filters: {
        formatDate: (value) => {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD hh:mm');
            }
        },
        year: (value) => {
            if (value) {
                return moment(String(value)).format('YYYY');
            }
        },
        formatShortDate: (value) => {
            if (value) {
                let year = moment(String(value)).format('YYYY');
                let month = moment(String(value)).format('MM');
                let day = moment(String(value)).format('DD');
                let hours = moment(String(value)).format('HH');
                let minutes = moment(String(value)).format('mm');

                //2020. augusztus 12., 9:17 perc
                return year + '. ' + months[parseInt(month)].toLowerCase()+' '+parseInt(day)+'., '+hours+':'+minutes;
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    months: months,
}

export const months = [
    '',
    'Január',
    'Február',
    'Március',
    'Április',
    'Május',
    'Június',
    'Július',
    'Augusztus',
    'Szeptember',
    'Október',
    'November',
    'December'
]